import { Suspense } from 'react';

import { ComponentWrapper } from '@trello/component-wrapper';
import { useLazyComponent } from '@trello/use-lazy-component';

import type { ClosedBoardsButtonProps } from './ClosedBoardsButton';

export const ClosedBoardsButtonLazyWrapped = (
  props: ClosedBoardsButtonProps,
) => {
  const ClosedBoardsButton = useLazyComponent(
    () =>
      import(
        /* webpackChunkName: "closed-boards-button" */ './ClosedBoardsButton'
      ),
    { namedImport: 'ClosedBoardsButton' },
  );

  return (
    <ComponentWrapper>
      <Suspense fallback={null}>
        <ClosedBoardsButton {...props} />
      </Suspense>
    </ComponentWrapper>
  );
};
